<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  },
  created() {
    this.initScrollOption();
    this.initGlobalCubeUi();
  },
  methods: {
  	// 全局分页配置
    initScrollOption() {
      // down   是否开启下拉刷新
      // up     是否开启上拉加载
      // size   开启上拉加载的条数下限
      // length 当前条数
      window.scrollOption = ({
        down = false, up = true, size = 11, length = 11,
      }) => ({
        pullDownRefresh: down
          ? {
            threshold: 90,
            stopTime: 600,
            txt: '刷新成功',
          } : false,
        pullUpLoad: up && size <= length
          ? {
            threshold: -20,
            txt: {
              more: '上拉加载更多...',
              noMore: '没有更多数据...',
            },
          }
          : false,
        scrollbar: true,
      })
    },
    /**
       * 注入cube-ui常用组件到全局window对象
       */
    initGlobalCubeUi() {
      // type可选择:correct,error,warn,loading,txt
      window.loading = '';
      window.toast = (msg, type = 'error',time) => {
        this.$createToast({
          txt: msg,
          type,
          time: time || 1000,
        }).show();
      };
      window.showLoading = (txt = '加载中...') => {
        loading = this.$createToast({
          txt,
          mask: true,
          time: 0,
        })
        loading.show()
      }
      window.hideLoading = () => {
        if (loading) {
          loading.hide()
        }
      }
    }
  }
}
</script>

<style>
	.cube-toast-tip{
		max-width: 15.4em;
	}
</style>

<style lang='less' scoped>
	

</style>
